import React, { useEffect, useState } from "react";
import { Card, Button, Row, Col, Spinner, Modal } from "react-bootstrap";

import { toast, ToastContainer } from "react-toastify";

import { useParams, useNavigate } from "react-router-dom";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
// import countryData from "react-phone-input-2/lib/countries";

function SupplierDetails() {
  const { id } = useParams(); // supplier id from route
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [supplier, setSupplier] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [isDeleting, setIsDeleting] = useState(false);


const handleDeleteSupplier = async () => {
  setIsDeleting(true);

  const requestBody = {
    customer_id: Number(localStorage.getItem("customer_id")),
    api_key: localStorage.getItem("api_key"),
    user_id: Number(localStorage.getItem("user_id")),
    language: "en",
    id: Number(id),
  };

  try {
    const response = await simplePostCall(
      ApiConfig.supplierDelete,
      JSON.stringify(requestBody)
    );
console.log('jaosn--', response.result)
    if (response?.result) {
      toast.success(response?.message || "Supplier deleted successfully");
      setShowDeleteModal(false);

      // 🔁 Redirect after delete
      setTimeout(() => {
        navigate("/accountant/suppliers");
      }, 1500);
    } else {
      toast.error(response?.message || "Failed to delete supplier");
    }
  } catch (error) {
    console.error("Delete supplier error:", error);
    toast.error("Network error occurred");
  } finally {
    setIsDeleting(false);
  }
};

  // helper to safely show value
  const val = (v) =>
    v !== null && v !== undefined && v !== "" ? v : "-";

  // find country by isoCode (AE, IN, etc.)
  const getCountryInfo = (isoCode) => {
    // return countryData.find(
    //   (c) => c[1].toUpperCase() === isoCode?.toUpperCase()
    // );
  };

  useEffect(() => {
    fetchSupplierDetails();
  }, []);

  const fetchSupplierDetails = async () => {
    setLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: Number(id),
    };

    try {
      const response = await simplePostCall(
        ApiConfig.supplierView,
        JSON.stringify(requestBody)
      );

      if (response?.result && response?.data?.length > 0) {
        setSupplier(response.data[0]);
      } else {
        setSupplier(null);
      }
    } catch (error) {
      console.error("Supplier view error:", error);
      setSupplier(null);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- LOADING ---------------- */
  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  /* ---------------- NO DATA ---------------- */
  if (!supplier) {
    return <div className="text-center py-5">No supplier data found</div>;
  }

  const countryInfo = getCountryInfo(supplier.supplier_nationality);

  return (
    <div className="container-fluid py-4">
          <ToastContainer position="top-right" autoClose={3000} />
      {/* HEADER */}
      <div className="bg-white p-3 rounded shadow-sm mb-3 d-flex justify-content-between align-items-center">
        <h5 className="mb-0 fw-bold">Supplier Details</h5>
        <div className="d-flex gap-2">
          <Button
            size="sm"
            variant="info"
            onClick={() =>
       
              navigate(`/accountant/update-supplier/${supplier.supplier_id}`)
            }
          >
            Edit
          </Button>
        <Button
  size="sm"
  variant="danger"
  onClick={() => setShowDeleteModal(true)}
>
  Delete
</Button>
        </div>
      </div>

      {/* CONTENT CARD */}
      <Card className="shadow-sm" style={{ backgroundColor: "#fff" }}>
        <Card.Body>
          <Row>
            {/* LEFT SECTION */}
            <Col md={4} className="border-end">
              <div className="text-center mb-4">
                <div
                  style={{
                    background: "#eceaea",
                    borderRadius: "25px",
                    padding: "10px",
                    fontWeight: "600",
                  }}
                >
                  {supplier.supplier_name
                    
                    /* ?.toUpperCase() */ || "--"}
                </div>
              </div>

              <h6 className="fw-bold mb-3">Contact Information</h6>

              <div className="mb-2 d-flex">
                <strong style={{ width: "70px" }}>Email:</strong>
                <span className="text-primary">
                  {val(supplier.supplier_email)}
                </span>
              </div>

              <div className="d-flex">
                <strong style={{ width: "70px" }}>Phone:</strong>
                <span>
                  {countryInfo?.[3] || ""}{" "}
                  {val(supplier.supplier_mobile)}
                </span>
              </div>
            </Col>

            {/* RIGHT SECTION */}
            <Col md={8}>
              <h6 className="fw-bold mb-3">General information</h6>

              <Row className="mb-3 border-bottom pb-2">
                <Col md={3} className="fw-bold">
                  Address
                </Col>
                <Col md={9}>
                  {val(supplier.supplier_address)}
                </Col>
              </Row>

              <Row className="mb-3 border-bottom pb-2">
                <Col md={3} className="fw-bold">
                  City
                </Col>
                <Col md={9}>
                  {val(supplier.supplier_city)}
                </Col>
              </Row>

              <Row>
                <Col md={3} className="fw-bold">
                  Nationality
                </Col>
                <Col md={9}>
                {supplier.supplier_nationality || "-"}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Modal
  show={showDeleteModal}
  onHide={() => !isDeleting && setShowDeleteModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Delete Supplier</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    Are you sure you want to delete this supplier?
    <br />
    {/* <strong>This action cannot be undone.</strong> */}
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowDeleteModal(false)}
      disabled={isDeleting}
    >
      Cancel
    </Button>

    <Button
      variant="danger"
      onClick={handleDeleteSupplier}
      disabled={isDeleting}
    >
      {isDeleting ? <Spinner size="sm" /> : "Delete"}
    </Button>
  </Modal.Footer>
</Modal>
    </div>
  );
}

export default SupplierDetails;
